<template lang="pug">
    v-container
        v-card 
            v-toolbar( color="primary" dark flat )
                v-toolbar-title RENDICIÓN DE PAGOS 
                    v-icon attach_money
            v-data-table( :headers="headers" :items="items" no-data-text="Sin rendiciones." rows-per-page-text="Rendiciones por pagina." )
                template( slot="items" slot-scope="props" )
                    td {{ props.item.id }}
                    td {{ props.item.sl_customer.business_name }}
                    td {{ props.item.sl_customer.rut }}
                    td {{ props.item.sl_detail_ground_seller_payment_records.length }} documento(s)
                    td {{ props.item.sl_customer.pch_payment_condition.type }}
                    td.text-xs-center $ {{ props.item.total }}
                    td {{ props.item.created_at }}
                    td {{ props.item.sl_ground_seller.hr_employee.names + ' ' +  props.item.sl_ground_seller.hr_employee.last_name1 + ' ' +  props.item.sl_ground_seller.hr_employee.last_name2 }}
                    td.text-xs-center
                        v-btn( @click="show( props.item )" color="success" depressed v-if="props.item.registered_in_cash_desk" )
                            v-icon done_all
                        v-tooltip( bottom v-else )
                            template( slot="activator" )
                                v-btn( @click="verify( props.item )" color="error" depressed )
                                    v-icon attach_money
                            span sin registrar en caja
        v-dialog(  v-model="open" width="1080" )
            v-toolbar( color="primary" dark flat )
                v-toolbar-title Verificar pago
                v-spacer
                v-toolbar-items
                    v-btn( @click="open = false" color="transparent" icon depressed large )
                        v-icon close
            v-card( elevation="0" )
                v-card-text
                    v-form-payment-verify( :item="selected" @success="reset" :variant="variant" )
</template>

<script>
    //
    import PaymentVerifyForm from '@/components/Forms/PaymentVerifyForm'
    import PaymentVerifyService from '@/services/API/paymentVerify'
    //
    export default {
        components: {
            'v-form-payment-verify': PaymentVerifyForm,
        },
        data () {
            return {
                headers: [
                    {
                        text: 'N°',
                        sortable: true,
                        value: 'id',
                        width: '5%',
                    },
                    {
                        text: 'CLIENTE',
                        sortable: true,
                        value: 'sl_customer.business_name',
                    },
                    {
                        text: 'RUT',
                        sortable: true,
                        value: 'sl_customer.rut',
                    },
                    {
                        text: 'DETALLE',
                        sortable: true,
                        value: 'sl_customer.sl_detail_ground_seller_payment_records.length',
                    },
                    {
                        text: 'CONDICIÓN',
                        sortable: true,
                        value: 'sl_customer.pch_payment_condition.type',
                    },
                    {
                        text: 'MONTO',
                        sortable: true,
                        value: 'total',
                        width: '10%',
                        align: 'center',
                    },
                    {
                        text: 'FECHA',
                        sortable: true,
                        value: 'created_at',
                    },
                    {
                        text: 'VENDEDOR',
                        sortable: false,
                        value: 'sl_ground_seller',
                    },
                    {
                        text: 'REGISTRADO EN CAJA',
                        sortable: false,
                        value: 'verify',
                        width: '10%',
                        align: 'center',
                    },
                ],
                items: [
                ],
                open: false,
                selected: {},
                variant: 'verify'
            }
        },
        methods: {
            async reset () {
                this.open   = false
                this.items  = ( await PaymentVerifyService.fetchAll() ).data
            },
            show ( payment_record ) {
                this.open       = true
                this.selected   = payment_record
                this.variant    = 'show'
            },
            verify ( payment_record ) {
                this.open       = true
                this.selected   = payment_record
                this.variant    = 'verify'
            },
        },
        async mounted () {
            this.reset()
        }
    }
</script>

